"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
const carabiners_1 = require("@clearsummit/carabiners");
const core_1 = require("@emotion/core");
const constants_1 = __importDefault(require("@/constants"));
const habit_journey_badge_1 = __importDefault(require("../habit-journey-badge"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const ProfileJourneys = ({ journeys, className, }) => ((0, core_1.jsx)("div", { className: (0, carabiners_1.joinStr)(styles_scss_1.default.container, className) },
    (0, core_1.jsx)("span", { className: styles_scss_1.default.title }, constants_1.default.profile.activeHabitJourneys),
    (0, core_1.jsx)("div", { className: styles_scss_1.default.content },
        journeys.length === 0 && (0, core_1.jsx)("span", null, constants_1.default.profile.noActiveJourneys),
        journeys.map((j) => ((0, core_1.jsx)(habit_journey_badge_1.default, { habitJourney: j }))))));
ProfileJourneys.defaultProps = {
    className: undefined
};
exports.default = ProfileJourneys;
